import { AnalyticsConnector, AnalyticsEnvironment, ApiEventsConnector } from '@inditex/coanalytjs';
import { Project, Tenant } from '@inditex/resellanl-ianalytics-events';
import { getEnv } from 'src/utils/EnvironmentTools';
import createConnectorConfig from './connector-config';
import { getHostData } from './device-provider';

const CONNECTOR_NAME = 'wsc-zararesell-api-events';

const ENVIRONMENT_MAP: Record<string, AnalyticsEnvironment> = {
	pre: AnalyticsEnvironment.PRE,
	pro: AnalyticsEnvironment.PRO,
};

const createAnalytics = (): AnalyticsConnector => {
	const env = getEnv();
	const environment = ENVIRONMENT_MAP[env?.env ?? ''] ?? AnalyticsEnvironment.PRE;
	const { appVersion } = getHostData();
	const version = process.env.REACT_APP_VERSION ?? appVersion;

	const analyticsConnector = new AnalyticsConnector({
		config: {
			environment,
			tenant: Tenant.ZP,
			project: Project.RESELLANL,
			projectKey: 'ZARSLLWEB',
			appVersion: version,
			apiKey: env?.coanalyticsApiToken || '',
			logsEnabled: true, 
		},
	});

	const connectorConfig = createConnectorConfig();

	const apiEventsConnector = new ApiEventsConnector(CONNECTOR_NAME, {
		config: {
			...connectorConfig,
			accessibility: { config: [], profile: 'default' },
		},
	});

	analyticsConnector.registerConnectors([apiEventsConnector]);

	return analyticsConnector;
};

export default createAnalytics;
